import { JetView } from 'webix-jet';
import {
    profile, // User profile configuration
    devConfig, // Development configuration settings
    countries, // List of countries
    paymentSystem, // Payment system configurations
    cashDesks, // Cash desk configurations
    agentList, // List of agents
} from 'config/config';

/**
 * Class representing the FilterSquareDayReportView.
 * Extends JetView to create a specific view for filtering square day reports.
 */
export default class FilterSquareDayReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true, // Read-only field
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'combo', // Combo box for BetShop selection
                            name: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label with icon
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Conditional visibility
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            id: 'BetShopId',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for combo box
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Trigger API call if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parse response
                                                            if (!resp.HasError) {
                                                                // Check for errors in response
                                                                vthis.parse(resp.Data); // Populate combo box with data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            hidden: !devConfig.getPermAction('viewSelectBetShop', 'Add'), // Conditional visibility
                            css: 'prm-viewSelectBetShop',
                        },
                        {
                            view: 'text', // Product input field
                            name: 'Product',
                            label: "<span class='icon-cubes'></span>" + _('Producto:'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Producto'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 180 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout adjustment
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form values on click
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Button label
                            hotkey: 'enter', // Hotkey for button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('squareDay:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
